module.exports = "https://bin.bnbstatic.com/_next/static/images/Runningman-MU-778222dc78b1b303f267d56daed8eb30.jpg";